import React, { useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EditScreenModal from '../../Designer/EditScreenModal.jsx'
import { getCurrentScreenType } from 'Helper/screenTypeHelpers'
import { openModal, closeModal } from 'actions/modalActions'
import { useDispatch, useSelector } from 'react-redux'
import { getContextName } from 'Helper/routeHelpers'
import { useLocation } from 'react-router-dom'
import LinkItem from './LinkItem.jsx'
import PropTypes from 'prop-types'
import _ from 'lodash'

const ScreenSubmenu = props => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const screenType = _.capitalize(getCurrentScreenType())
  const isDesignMode = useSelector(state => state.interactableState.uiDesignMode)
  const currentContext = getContextName(pathname)
  const showConfigure = isDesignMode && (currentContext === 'adminDisplay' || currentContext === 'patientDisplay' || currentContext === 'nurseDashboard')
  const currentScreenPath = useSelector(state => state.router?.match?.params?.screen)
  const isEdit = showConfigure && currentScreenPath && currentScreenPath !== ''

  let screenList = (props?.screens && props.screens.length > 0) ? _.cloneDeep(props.screens) : []

  const configureScreenModal = useCallback((isEdit) => {
    dispatch(openModal(
      'edit_screen_modal',
      {
        title: 'Configure ' + screenType + ' Screen',
        content: (
          <EditScreenModal
            isEdit={isEdit}
            closeSelf={() => { dispatch(closeModal('edit_screen_modal')) }}
          />
        ),
        closeable: true
      })
    )
  }, [isDesignMode, screenType])

  if ((!screenList || screenList.length == 0) && !showConfigure) {
    return null
  } else {
    screenList = screenList.sort((a, b) => {
      const textA = a.name ? a.name.toUpperCase() : ''
      const textB = b.name ? b.name.toUpperCase() : ''
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
    const disabledClass = props.disabled ? ' disabled' : ''

    return (
      <li className={'dropdown-submenu' + disabledClass}>
        <a
          className="dropdown-toggle"
          id="screensDropDown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          aria-label="screens menu"
        >
          <FontAwesomeIcon icon={['far', 'window-restore']} /> Screens
        </a>
        {props.disabled
          ? null
          : (
            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="screensDropDown"
            >
              {screenList.map((screen, idx) => {
                return (
                  <LinkItem
                    key={idx}
                    item={screen}
                    type="screen"
                    prefix={props.prefix}
                    context={currentContext}
                  />
                )
              })}
              {showConfigure && isEdit
                ? <li key={'edit screen'}>
                    <a
                      role="button"
                      aria-label={`add screen link`}
                      onClick={() => {
                        configureScreenModal(isEdit)
                      }}
                    >
                      &lt;Edit Current Screen&gt;
                    </a>
                  </li>
                : null
              }
              {showConfigure
                ? <li key={'add screen'}>
                    <a
                      role="button"
                      aria-label={`add screen link`}
                      onClick={() => {
                        configureScreenModal(false)
                      }}
                    >
                      &lt;Add Screen&gt;
                    </a>
                  </li>
                : null
              }
            </ul>
          )}
      </li>
    )
  }
}

ScreenSubmenu.propTypes = {
  // A route that may need to be prefixed to the paths in the screen menu for example,
  // from the patient menu, screens will need to be prefixed by /dashboard/patient/:patientId
  routePrefix: PropTypes.string,
  // An array of screen objects
  screens: PropTypes.arrayOf(
    PropTypes.shape({
      // User visible screen name
      name: PropTypes.string.isRequired,
      // Screen name used in the url
      path: PropTypes.string.isRequired,
      // Should the screen be listed in the screen menu
      selectable: PropTypes.bool.isRequired,
      // Array of windows in the screen
      windows: PropTypes.array.isRequired
    }).isRequired
  ),
  disabled: PropTypes.bool
}

export default ScreenSubmenu
